/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditMusicParamsDto
 */
export interface EditMusicParamsDto {
    /**
     * 
     * @type {number}
     * @memberof EditMusicParamsDto
     */
    duration: number;
    /**
     * 
     * @type {number}
     * @memberof EditMusicParamsDto
     */
    startTime?: number;
    /**
     * 
     * @type {number}
     * @memberof EditMusicParamsDto
     */
    endTime?: number;
    /**
     * 
     * @type {number}
     * @memberof EditMusicParamsDto
     */
    keepTimes?: number;
}

/**
 * Check if a given object implements the EditMusicParamsDto interface.
 */
export function instanceOfEditMusicParamsDto(value: object): value is EditMusicParamsDto {
    if (!('duration' in value) || value['duration'] === undefined) return false;
    return true;
}

export function EditMusicParamsDtoFromJSON(json: any): EditMusicParamsDto {
    return EditMusicParamsDtoFromJSONTyped(json, false);
}

export function EditMusicParamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditMusicParamsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'duration': json['duration'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'keepTimes': json['keepTimes'] == null ? undefined : json['keepTimes'],
    };
}

export function EditMusicParamsDtoToJSON(json: any): EditMusicParamsDto {
    return EditMusicParamsDtoToJSONTyped(json, false);
}

export function EditMusicParamsDtoToJSONTyped(value?: EditMusicParamsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'duration': value['duration'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'keepTimes': value['keepTimes'],
    };
}

